/* SUNKIS homepage and product page behaviour (current Cloudflare PDP design).
   Gallery, reviews carousel, lazy video, FAQ/privacy sidebar, mobile "Notify me" bar and the waitlist pop-up,
   which subscribes the email to a Klaviyo list with the store's public API key and then
   (section setting) creates a Shopify customer subscribed to email marketing.
   Header menu, cart drawer and plan cards stay in sunkis-storefront.js. */
(function () {
  if (window.__sunkisHomeInit) return;
  window.__sunkisHomeInit = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var KLAVIYO_REVISION = '2024-10-15';

  /* ---------- gallery ---------- */
  function initGallery(gal) {
    if (gal.__skInit) return;
    gal.__skInit = true;
    var main = $('[data-sk-gallery-main]', gal);
    var thumbs = $$('[data-sk-thumb]', gal);
    var dots = $$('.dots i', gal);
    var prev = $('[data-sk-gallery-prev]', gal);
    var next = $('[data-sk-gallery-next]', gal);
    var cur = 0;
    if (!main || !thumbs.length) {
      if (prev) prev.disabled = true;
      if (next) next.disabled = true;
      return;
    }
    function edges() {
      if (prev) prev.disabled = cur === 0;
      if (next) next.disabled = cur === thumbs.length - 1;
    }
    function show(i, fromUser) {
      cur = (i + thumbs.length) % thumbs.length;
      var t = thumbs[cur];
      var src = t.getAttribute('data-src');
      var set = t.getAttribute('data-srcset') || '';
      var alt = t.getAttribute('data-alt') || '';
      main.style.opacity = 0.35;
      var img = new Image();
      img.sizes = main.sizes;
      img.onload = img.onerror = function () {
        main.srcset = set;
        main.src = src;
        main.alt = alt;
        main.style.opacity = 1;
      };
      if (set) img.srcset = set;
      img.src = src;
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === cur); });
      if (fromUser && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      edges();
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i, true); }); });
    if (prev) prev.addEventListener('click', function () { show(cur - 1, true); });
    if (next) next.addEventListener('click', function () { show(cur + 1, true); });
    var stage = $('[data-sk-gallery-stage]', gal);
    var x0 = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1), true);
      });
    }
    edges();
  }

  /* ---------- reviews carousel ---------- */
  function initReviews(root) {
    if (root.__skInit) return;
    root.__skInit = true;
    var rv = $('[data-sk-review-track]', root);
    if (!rv) return;
    var cards = $$('article', rv);
    if (!cards.length) return;
    function cardW() { return cards[0].getBoundingClientRect().width || 1; }
    function slideTo(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      rv.scrollTo({ left: cards[i].offsetLeft - rv.offsetLeft, behavior: 'smooth' });
    }
    function index() { return Math.round(rv.scrollLeft / cardW()); }
    function atEnd() { return rv.scrollLeft + rv.clientWidth >= rv.scrollWidth - 4; }
    var p = $('[data-sk-review-prev]', root);
    var n = $('[data-sk-review-next]', root);
    if (p) p.addEventListener('click', function () { if (rv.scrollLeft <= 4) slideTo(cards.length - 1); else slideTo(index() - 1); });
    if (n) n.addEventListener('click', function () { if (atEnd()) slideTo(0); else slideTo(index() + 1); });
    var tabs = $$('[data-sk-review-tab]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        slideTo(Number(t.getAttribute('data-start') || 0));
      });
    });
    /* drag to slide with a mouse; touch already scrolls natively */
    var drag = null, moved = false;
    rv.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: rv.scrollLeft };
      moved = false;
      rv.classList.add('drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (Math.abs(dx) > 3) moved = true;
      rv.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!drag) return;
      drag = null;
      rv.classList.remove('drag');
      if (moved) slideTo(index());
    });
    rv.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); slideTo(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); slideTo(index() - 1); }
    });
  }

  /* ---------- mini FAQ: one open at a time (for browsers without details[name]) ---------- */
  function initFaq() {
    var items = $$('#faq-mini details');
    items.forEach(function (d) {
      if (d.__skInit) return;
      d.__skInit = true;
      d.addEventListener('toggle', function () {
        if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------- FAQ and privacy pages: sidebar follows the reader, and a sidebar link opens its question ---------- */
  function initSideNav() {
    var links = $$('.faq-page .side a');
    if (!links.length || links[0].__skInit) return;
    var map = {};
    links.forEach(function (a) {
      a.__skInit = true;
      map[a.getAttribute('href').slice(1)] = a;
      a.addEventListener('click', function () {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (t && t.tagName === 'DETAILS') t.open = true;
      });
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var a = map[e.target.id];
        if (!a) return;
        links.forEach(function (l) { l.classList.remove('cur'); });
        a.classList.add('cur');
      });
    }, { rootMargin: '-10% 0px -80% 0px' });
    $$('.faq-page .qa .q').forEach(function (q) { io.observe(q); });
  }

  /* a link to a question further down the page (e.g. #cookies from the cookie banner) opens it */
  function openHashTarget() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var t = document.getElementById(id);
    if (!t) return;
    var d = t.tagName === 'DETAILS' ? t : t.querySelector('details');
    if (d) d.open = true;
  }

  /* ---------- lazy autoplay video ---------- */
  function initVideos() {
    var vids = $$('video[data-lazy-play]').filter(function (v) { return !v.__skInit; });
    if (!vids.length) return;
    vids.forEach(function (v) { v.__skInit = true; });
    function start(v) {
      if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); }
      v.preload = 'auto';
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) start(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: '600px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- waitlist pop-up ---------- */
  var wl = null;
  var PENDING_KEY = 'sunkis-notify-pending';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function readPending() {
    try { return JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch (x) { return null; }
  }
  function clearPending() {
    try { sessionStorage.removeItem(PENDING_KEY); } catch (x) {}
  }

  function announce(source, email) {
    window.dispatchEvent(new CustomEvent('sunkis:waitlist', { detail: { email: email, source: source } }));
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('sunkis_notify_signup', { source: source });
      }
    } catch (x) {}
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'sunkis_notify_signup', signup_source: source });
  }

  function waitlist() {
    var root = $('[data-sk-waitlist]');
    if (!root) return null;
    if (root.__sk) return root.__sk;
    var card = $('.wl-card', root);
    var form = $('form.wl-form', root);
    var input = form ? $('input[type="email"]', form) : null;
    var err = $('[data-sk-wl-err]', root);
    var fail = $('[data-sk-wl-fail]', root);
    var ok = $('[data-sk-wl-ok]', root);
    var submit = form ? $('button[type="submit"]', form) : null;
    var cfg = {
      key: root.getAttribute('data-klaviyo-key') || '',
      list: root.getAttribute('data-klaviyo-list') || '',
      source: root.getAttribute('data-source') || 'SUNKIS notify me',
      shopify: root.getAttribute('data-shopify-customer') === 'true'
    };
    var last = null;

    function loadImages() {
      $$('[data-srcset]', root).forEach(function (s) { s.srcset = s.getAttribute('data-srcset'); s.removeAttribute('data-srcset'); });
      $$('img[data-src]', root).forEach(function (i) { i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); });
    }
    function open() {
      loadImages();
      last = document.activeElement;
      root.removeAttribute('inert');
      root.classList.add('open');
      document.documentElement.classList.add('wl-lock');
      setTimeout(function () { (ok && !ok.hidden ? card : input || card).focus(); }, 60);
    }
    function close() {
      root.classList.remove('open');
      root.setAttribute('inert', '');
      document.documentElement.classList.remove('wl-lock');
      if (last && last.focus) last.focus();
    }
    function showOk() {
      if (form) form.hidden = true;
      if (ok) ok.hidden = false;
    }
    function showFail() {
      if (form) form.hidden = false;
      if (ok) ok.hidden = true;
      if (fail) fail.hidden = false;
    }
    root.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button,input,a[href]', card).filter(function (el) { return el.offsetParent !== null && !el.disabled; });
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });

    /* Klaviyo client subscription (public key + list ID from Theme settings > Klaviyo). */
    function subscribe(email) {
      if (!cfg.key || !cfg.list) {
        if (window.console) console.warn('SUNKIS waitlist: add the Klaviyo public API key and list ID in Theme settings > Klaviyo.');
        return Promise.reject(new Error('Klaviyo is not configured'));
      }
      var request = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: cfg.source,
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: cfg.list } } }
          }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
        return true;
      });
      var timeout = new Promise(function (resolve, reject) { setTimeout(function () { reject(new Error('Klaviyo timed out')); }, 6000); });
      return Promise.race([request, timeout]);
    }

    if (form && input) {
      input.addEventListener('input', function () {
        if (err) err.hidden = true;
        if (fail) fail.hidden = true;
        input.removeAttribute('aria-invalid');
      });
      /* Capture phase: runs before Shopify's spam protection, which only sees the second submit. */
      form.addEventListener('submit', function (e) {
        if (form.__skGo) return; /* second pass: let the browser and Shopify post the form */
        e.preventDefault();
        e.stopImmediatePropagation();
        var v = input.value.trim();
        if (!EMAIL_RE.test(v)) {
          if (err) err.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        if (fail) fail.hidden = true;
        if (submit) submit.disabled = true;
        subscribe(v).then(function () { return true; }, function (x) {
          if (window.console) console.warn('SUNKIS waitlist:', x && x.message);
          return false;
        }).then(function (klaviyoOk) {
          if (cfg.shopify) {
            /* Post the Shopify newsletter form as a normal page submit; the page comes back with ?notify=done. */
            try { sessionStorage.setItem(PENDING_KEY, JSON.stringify({ email: v, source: cfg.source, klaviyo: klaviyoOk })); } catch (x) {}
            if (submit) submit.disabled = false;
            form.__skGo = true;
            if (form.requestSubmit) form.requestSubmit(submit || undefined);
            else form.submit();
            if (submit) submit.disabled = true;
            return;
          }
          if (submit) submit.disabled = false;
          if (klaviyoOk) {
            announce(cfg.source, v);
            showOk();
            card.focus();
          } else {
            showFail();
          }
        });
      }, true);
    }

    /* Back from the Shopify form post: show the result in the pop-up. */
    function resume() {
      var params = new URLSearchParams(window.location.search);
      var serverError = $('[data-sk-wl-server-error]', root);
      var serverOk = $('[data-sk-wl-server-ok]', root);
      var pending = readPending();
      var done = params.get('notify') === 'done' || !!serverOk || (!!pending && params.get('customer_posted') === 'true');
      if (!done && !serverError) return;
      if (serverError) {
        clearPending();
        if (pending && input) input.value = pending.email || '';
        open();
        showFail();
      } else {
        open();
        showOk();
        announce((pending && pending.source) || cfg.source, pending && pending.email);
        clearPending();
      }
      try {
        params.delete('notify');
        params.delete('customer_posted');
        var q = params.toString();
        history.replaceState({}, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
      } catch (x) {}
    }

    root.__sk = { open: open, close: close, resume: resume };
    return root.__sk;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sk-notify]');
    if (!t) return;
    e.preventDefault();
    wl = waitlist();
    if (wl) wl.open();
  });

  /* ---------- mobile sticky "Notify me" bar ---------- */
  function initBar() {
    var bar = $('[data-sk-mbar]');
    var orig = $('#notify');
    if (!bar || !orig || bar.__skInit) return;
    bar.__skInit = true;
    var btn = $('button', bar);
    var foot = $('footer.footer');
    var origVisible = false, footVisible = false;
    function sync() {
      var cl = document.documentElement.classList;
      var on = !origVisible && !footVisible && !cl.contains('wl-lock') && !cl.contains('sk-cc-open'); /* hidden while the cookie notice shows */
      bar.classList.toggle('show', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { origVisible = es[0].isIntersecting; sync(); }).observe(orig);
      if (foot) new IntersectionObserver(function (es) { footVisible = es[0].isIntersecting; sync(); }).observe(foot);
    }
    new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function init() {
    var w = waitlist();
    if (w && !w.__resumed) { w.__resumed = true; w.resume(); }
    $$('[data-sk-gallery]').forEach(initGallery);
    $$('[data-sk-reviews]').forEach(initReviews);
    initFaq();
    initSideNav();
    openHashTarget();
    initVideos();
    initBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('hashchange', openHashTarget);
})();
